<template>
  <ion-card mode="ios" style="margin: 15px 0; background: #fff">
    <ion-card-header>
      <slide-y-up-transition :duration="700">
        <h6 v-show="show" class="text-up m-0">Przyznane bony</h6>
      </slide-y-up-transition>
    </ion-card-header>
    <ion-card-content style="padding-top: 0">
      <div v-for="(item,index) in vouchers" :key="index">
        <table class="table table-loyalty-vouchers">
          <thead>
          <tr>
            <th>{{ item.title }}</th>
            <th class="text-right">{{ item.unit }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <span style="display: inline-block; padding: 7px 7px 7px 0">{{ item.status.label }}</span>
              <ion-button v-if="item.status.active"
                          mode="ios"
                          fill="outline"
                          size="small"
                          @click="openPopover(item.month_number)">Zmień status
              </ion-button>
            </td>
            <td>{{ item.value }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>
</template>

<script>
  import {mapGetters} from "vuex";
  import ChangeVoucherStatusPopover from '@/popovers/ChangeVoucherStatusPopover.vue';

  export default {
    name: 'CardLoyaltyVouchers',
    props: ['sfa', 'year', 'vouchers'],
    computed: {
      ...mapGetters('profile', ['getProfile']),
    },
    data() {
      return {
        show: false
      }
    },
    mounted(){
      this.show = true;
    },
    methods: {
      openPopover(month){
        return this.$ionic.popoverController.create({
          component: ChangeVoucherStatusPopover,
          mode: 'ios',
          componentProps: {
            propsData: {
              store: this.$store, // ionic bug:
              route: this.$route, // https://github.com/ModusCreateOrg/ionic-vue/issues/38#issuecomment-428247908
              sfa: this.sfa,
              month: month,
              year: this.year,
              ph_slug: this.getProfile.slug
            },
          },
        }).then(m => m.present())
      }
    }
  }
</script>

<style lang="scss" scoped>
  ion-card-content {
    padding: 8px 12px;
  }
</style>